import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Tim Kalinowski, Founder, and CEO of LORE</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>Helping your business/product transform into a brand through communication, Tekrevol partners with Tim Kalinowski, Founder, and CEO of LORE, for S02 E04 of Technology For Change. Join the discussion and ask a question to our guests in the comment section and we'll answer them live!</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;